<template>
	<header class="fixed-top bg-primary-dark py-2" id="page-header">
		<b-container>
			<b-row class="align-items-center">
				<b-col cols="3" sm="3" md="2" lg="3" order="1" order-lg="1">
					<a  href="#app"
						v-scroll-to="{ el: '#app', offset: scrollOffset }"
						title="Gå till toppen">
						<img src="../assets/img/lidl_logo.svg" width="108" height="92" class="logo" alt="Lidl - Allt annat är olidligt">
					</a>
				</b-col>
				<b-col cols="3" sm="3" md="2" lg="6" order="3" order-lg="2">
					<b-navbar toggleable="lg" v-b-scrollspy="{ offset: 500 }" class="justify-content-center">
						<b-navbar-toggle target="nav_collapse" ref="navbarToggle">
							<a href="#" class="link d-block" @click.prevent="toggleBodyClass()">
								<span class="line d-block"></span>
								<span class="line d-block"></span>
								<span class="line d-block"></span>
								<span class="menu-text closed">Meny</span>
								<span class="menu-text opened">Stäng</span>
							</a>
						</b-navbar-toggle>
						<b-collapse is-nav
									id="nav_collapse"
									class="text-center justify-content-center">
							<b-navbar-nav>
								<b-nav-item href="#about"
											v-scroll-to="{ el: '#about', offset: scrollOffset }"
											@click.prevent="toggleBodyClass()">
									Om Lidl
									<span class="line"></span>
								</b-nav-item>
								<b-nav-item href="#ceo"
											v-scroll-to="{ el: '#ceo', offset: scrollOffset }"
											@click.prevent="toggleBodyClass()">
									Vd-ord
									<span class="line"></span>
								</b-nav-item>
								<b-nav-item href="#sustainability"
											v-scroll-to="{ el: '#sustainability', offset: scrollOffset }"
											@click.prevent="toggleBodyClass()">
									Värdekedja & strategi
									<span class="line"></span>
								</b-nav-item>
							</b-navbar-nav>
						</b-collapse>
					</b-navbar>
				</b-col>
				<b-col cols="auto" order="2" order-lg="3" class="mx-auto mx-lg-0 ml-lg-auto text-right">
					<b-btn  variant="secondary"
							class="d-block alt"
							:href="$creo.browserPdfLink(pdfLink.org, pdfLink.fallback, pdfLink.page)"
							target="_blank">
						Hållbarhetsredovisning
					</b-btn>
					<b-btn  variant="secondary"
							class="d-block alt"
							:href="$creo.browserPdfLink(pdfLinkShort.org, pdfLinkShort.fallback, pdfLinkShort.page)"
							target="_blank">
						Hållbarhet i korthet
					</b-btn>
				</b-col>
			</b-row>
		</b-container>
	</header>
</template>
<script>
	export default {
		props: {
			pdfLink: {
				default: null
			},
			pdfLinkShort: {
				default: null
			}
		},
		data () {
			return {
				headerHeight: 0,
				scrollOffset: 0
			}
		},
		methods: {
			handleResize (e) {
				this.headerHeight = document.getElementById('page-header').offsetHeight;
				this.scrollOffset = -this.headerHeight;
			},
			toggleBodyClass() {
				if(window.width < 992 && this.$refs.navbarToggle.$el.attributes['aria-expanded'].value == 'true') {
					document.body.classList.remove('modal-open');
				} else if(window.width < 992) {
					document.body.classList.add('modal-open');
				}
			}
		},
		created () {
			window.addEventListener('resize', this.handleResize);
		},
		mounted() {
			this.headerHeight = document.getElementById('page-header').offsetHeight;
			this.scrollOffset = -this.headerHeight;
		},
		beforeDestroy () {
			window.removeEventListener('resize', this.handleResize);
		}
	}
</script>
